import { useEffect, useState } from 'react';
import { getProjects } from '@agilytics/utils/jira';
import { useAgilyticsState, useAgilyticsDispatch } from '@agilytics/global-state';

export default function useProjects(query) {
  const { accessToken, projects, cloudId } = useAgilyticsState();
  const [stateProjects, setProjects] = useState(projects);

  const dispatch = useAgilyticsDispatch();

  useEffect(() => {
    if (accessToken && cloudId) {
      const fetchProjects = async () => {
        const projects = await getProjects(accessToken, cloudId, query);
        dispatch({ type: 'updateProjects', projects });
        setProjects(projects);
      };

      fetchProjects();
    }
  }, [accessToken, cloudId, dispatch, setProjects, query]);

  return stateProjects;
}
